// extracted by mini-css-extract-plugin
export default {"commentLine":"vacancyCommentLine-module__commentLine--kIFbF","author":"vacancyCommentLine-module__author--v5OFR"};